import {
  PATH_TO_SUBSCRIPTION_PRODUCTS_STATE,
  subscriptionProductsReducer
} from "seneca-common/features/subscriptions/features/subscription-products/state";
import subscriptionProductsReducerWrapper from "seneca-common/features/subscriptions/features/subscription-products/state/reducers/subscriptionProductsReducerWrapper";
import {
  PATH_TO_USER_TYPE_STATE,
  userTypeReducer
} from "seneca-common/features/userType";
import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_SUBSCRIPTIONS_STATE } from "./consts";
import subscriptionsReducer from "./reducers";
import { userTypeReducerWrapper } from "./reducers/userTypeReducerWrapper";

const reducerRegistry = ReducerRegistry.getInstance();

reducerRegistry.initialise(PATH_TO_SUBSCRIPTIONS_STATE, builder => {
  builder
    .register(PATH_TO_SUBSCRIPTIONS_STATE, subscriptionsReducer)
    .enhance(
      PATH_TO_SUBSCRIPTION_PRODUCTS_STATE,
      subscriptionProductsReducer,
      subscriptionProductsReducerWrapper
    )
    .enhance(PATH_TO_USER_TYPE_STATE, userTypeReducer, userTypeReducerWrapper);
});

// using 'require' to make sure that analytics code executes AFTER reducer is registered
require("./analytics");

export { subscriptionsReducer, PATH_TO_SUBSCRIPTIONS_STATE };

// actions
export {
  receiveSubscriptions,
  receiveSubscription,
  updateSubscription,
  cancelSubscription,
  createSubscription,
  restartMySubscription,
  setPaymentError,
  resetPaymentError,
  secureAuthenticationProcessingStarted,
  secureAuthenticationProcessingFinished,
  createPaymentMethodStarted,
  createPaymentMethodFinished
} from "./actions";
export {
  fetchAllSubscriptionsActionFactory,
  fetchSubscriptionActionFactory,
  updateSubscriptionActionFactory,
  createSubscriptionActionFactory
} from "seneca-common/features/subscriptions/state/actions/meta";

// selectors
export {
  getSubscription,
  getLiveStripeSubscriptionId,
  getSubscriptions,
  getSortedSubscriptionIds,
  userHasSubscription,
  hasLiveSubscription,
  hasManagedSubscription,
  hasTransferableSubscription,
  hasSingleStripeSubscription,
  hasSubscriptionWithFailedPayment,
  getSubscriptionIdWithFailedPayment,
  getSubscriptionIdWithPendingAuthentication,
  canGetMISUpgradeSubscription,
  getSubscriptionProductId,
  getSubscriptionStatus,
  subscriptionPaymentSucceeded,
  subscriptionPaymentFailed,
  subscriptionExists,
  subscriptionPaymentRequiresAuthentication,
  subscriptionIsActive,
  subscriptionIsManaged,
  subscriptionIsCancelled,
  hasActiveSubscription,
  isSubscriptionLive,
  hasStripeSubscription,
  userHasExpiredSubscription,
  subscriptionThatRequiresAction,
  canCancelSubscription,
  getCancelledSubscriptionId,
  canRenewSubscription,
  hasSubscriptionWithPendingAuthentication,
  canRestartSubscription,
  getSubscriptionPaymentError,
  secureCustomerAuthenticationIsOngoing,
  paymentMethodCreationIsOngoing,
  stripeInteractionIsOngoing,
  canUpdatePaymentMethod,
  getSubscriptionExpiryDate,
  subscriptionHasExpired,
  hasSubscriptionCardDetails,
  getSubscriptionCardBrand,
  getSubscriptionCardLast4Digits,
  getIsUpgrading,
  getUpgradeSubscriptionProductId,
  getUpgradeProratedPrice,
  getLiveManagedSubscriptionId,
  getAddonProductIds,
  getSubscriptionInitialPurchaseDate,
  canSubscriptionBeTransferred
} from "seneca-common/features/subscriptions/state/selectors";

export {
  // fetch
  subscriptionsIsFetching,
  subscriptionsFetchSucceeded,
  subscriptionsFetchErrored,
  subscriptionsFetchFinished,
  subscriptionIsFetching,
  subscriptionFetchSucceeded,
  subscriptionFetchErrored,
  subscriptionFetchFinished,
  subscriptionsNeedsFetching,
  subscriptionIsUpdating,
  subscriptionUpdateSucceeded,
  subscriptionUpdateErrored,
  subscriptionUpdateErrorMessage,
  subscriptionUpdateFinished,
  subscriptionIsBeingCreated,
  createSubscriptionSucceeded,
  createSubscriptionErrored,
  createSubscriptionFinished,
  createSubscriptionErrorMessage
} from "seneca-common/features/subscriptions/state/selectors/state/subscriptions/meta";

// models
export type { Subscriptions } from "./models/subscriptions";
